"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var action_context_1 = require("../action-context/action-context");
function onClick(e) {
    if (!(e.currentTarget instanceof HTMLElement))
        return;
    if (!e.currentTarget.dataset.phocusAction)
        return;
    if (e.currentTarget.disabled)
        return;
    action_context_1.ActionContextService.setContext(e.currentTarget);
    action_context_1.ActionContextService.triggerAction(e.currentTarget.dataset.phocusAction, e);
}
exports.triggerableTags = ["button", "a"];
function addTrigger(elt) {
    if (!elt.dataset.phocusAction)
        return;
    var action = elt.dataset.phocusAction;
    if (exports.triggerableTags.indexOf(elt.tagName.toLowerCase()) < 0 &&
        elt.getAttribute("role") !== "button") {
        console.error(elt.tagName + " (assigned to trigger " + action + ") is not an accessible tag. Use a <button> or an <a>.");
        console.info("Setting role to 'button' to compensate.");
        elt.setAttribute("role", "button");
    }
    var oldContext = action_context_1.ActionContextService.contextStack; // this store and restore thing; do it with an internal stack stack?
    try {
        // Add button labels, including any keyboard shortcuts
        action_context_1.ActionContextService.setContext(elt);
        var actionInContext = action_context_1.ActionContextService.actionForName(action);
        if (!actionInContext) {
            console.error("No action found for name " + action, action_context_1.ActionContextService.contextStack);
            return;
        }
        if (!elt.dataset.phocusDoNotLabel) {
            elt.title = actionInContext.action.label();
            elt.setAttribute("aria-label", actionInContext.action.label());
        }
        // Set text (if elt is empty)
        if (/^\s*$/.test(elt.innerHTML)) {
            elt.innerHTML = actionInContext.action.name;
        }
        else if (elt.dataset.phocusAutolabel) {
            var label = elt.querySelector(elt.dataset.phocusAutolabel);
            if (label) {
                label.innerHTML = actionInContext.action.name;
            }
            else {
                console.warn("Asked to autolabel " + elt.dataset.phocusAutolabel + ", but no such element exists inside " + elt + ".");
            }
        }
        // Add click handler
        elt.addEventListener("click", onClick);
    }
    finally {
        // Restore context previously in progress
        action_context_1.ActionContextService.contextStack = oldContext;
    }
}
exports.addTrigger = addTrigger;
function removeTrigger(elt) {
    elt.removeEventListener("click", onClick);
}
exports.removeTrigger = removeTrigger;
//# sourceMappingURL=add-trigger.js.map